/* sk-filament-finder — フィラメント絞り込み検索（クライアント側）
   データ源: セクションが埋め込む <script type="application/json" id="skff-data">
   （Liquidレンダ時にコレクションから生成＝価格・在庫は常に最新）。
   温度・内容量・径は判断行metafield（custom.decision_rows）のパース値。
   値が取れない商品は隠さず「未整備」表示にする（推定で埋めない）。 */
(function () {
  'use strict';

  var dataEl = document.getElementById('skff-data');
  var root = document.getElementById('skff');
  if (!dataEl || !root) return;

  var RAW;
  try { RAW = JSON.parse(dataEl.textContent); } catch (e) { return; }
  // Liquid の paginate 上限250で読み込めなかった件数（セクションが data-omitted で渡す）
  var OMITTED = parseInt(dataEl.getAttribute('data-omitted'), 10);
  if (!isFinite(OMITTED) || OMITTED < 0) OMITTED = 0;

  var T_LO = 150, T_HI = 320;
  var DASH = '[〜～~\\-–—−]'; // 〜～~-–—−
  var RANGE_RE = new RegExp('(\\d{2,3})\\s*(?:℃|°C|度)?\\s*' + DASH + '\\s*(\\d{2,3})');
  var SINGLE_RE = /(\d{2,3})\s*(?:℃|°C)/;

  function parseTempRow(text) {
    if (!text) return null;
    var m = RANGE_RE.exec(text);
    if (m) return { lo: +m[1], hi: +m[2] };
    m = SINGLE_RE.exec(text);
    if (m) return { lo: +m[1], hi: +m[1] };
    return null;
  }
  function parseWeight(text) {
    if (!text) return null;
    text = text.replace(/,/g, ''); // 「3,000g」等の千位区切り対応
    var m = /([\d.]+)\s*(?:kg|KG|Kg|ｋｇ)/.exec(text);
    var g = null;
    if (m) g = Math.round(parseFloat(m[1]) * 1000);
    // 全角「ｇ」は語境界(\b)が立たないので半角と分けて書く（'750ｇ' が未整備扱いになっていた）
    else { m = /(\d{3,4})\s*(?:[gG]\b|ｇ)/.exec(text); if (m) g = +m[1]; }
    if (g === null) return null;
    var end = m.index + m[0].length;
    // 後置きの乗数「1kg×4」
    var mm = /^\s*[×xX*]\s*(\d{1,2})/.exec(text.slice(end, end + 6));
    if (mm) g *= +mm[1];
    else {
      // 前置きの乗数「4×250g」。後置きが無いときだけ見る。
      // 直前が数字か小数点なら乗数ではない（'1.75×250g' の 75 を拾わないため）。
      var mp = /(?:^|[^\d.])(\d{1,2})\s*[×xX*]\s*$/.exec(text.slice(0, m.index));
      if (mp) g *= +mp[1];
    }
    return (g >= 50 && g <= 20000) ? g : null;
  }
  function parseDia(text) {
    if (!text) return null;
    var m = /(1\.75|2\.85|3\.00)\s*(?:mm|ｍｍ)/.exec(text);
    return m ? m[1] : null;
  }

  var FEATURES = [
    ['軽量発泡', ['エアロ', 'Aero', '発泡']],
    ['カーボン配合', ['カーボン', '-CF', ' CF', 'CF15', 'CF10', 'CF20']],
    ['ガラス繊維配合', ['GF', 'ガラス繊維']],
    ['難燃', ['難燃', ' FR', 'FR）', 'V-0']],
    ['水溶性サポート', ['水溶性', 'PVA', 'BVOH']],
    ['高速造形対応', ['高速', 'Hyper', 'Sonic', 'Rapid', 'HF']],
    ['マット', ['マット', 'Matte', 'つや消し']],
    ['シルク・光沢', ['シルク', 'Silk', '光沢', 'メタリック', 'Metallic', 'メタル', 'ギャラクシー', 'Galaxy', '金属調', 'スパークル', 'Sparkle']],
    ['ラメ・大理石調', ['マーブル', 'Marble', '大理石調', 'スパークル', 'Sparkle']],
    ['半透明・クリア', ['半透明', 'Translucent', 'クリア', '透明']],
    ['グラデーション', ['グラデ', 'Gradient']],
    ['木質調', ['木質', '木粉', 'Wood']],
    ['蓄光', ['蓄光', 'Glow']]
  ];

  /* 用途プリセット: mats=素材(OR) / feas=特徴(OR) / mode:'and'=素材と特徴の両方を要求
     d=適用中に表示する説明。素材の一般的特性によるショートカットで、個別商品の性能保証ではない */
  var PRESETS = [
    { k: 'beginner', label: 'はじめての1本', mode: 'or', mats: ['PLA', 'PLA+'], feas: [], d: '反りにくく扱いやすい定番PLA' },
    { k: 'figure', label: 'フィギュア・模型', mode: 'and', mats: ['PLA', 'PLA+'], feas: ['マット'], d: '積層痕が目立ちにくいマット系PLA' },
    { k: 'strong', label: '強度がほしい', mode: 'or', mats: ['PLA+', 'PA', 'PA-CF', 'PA-CNF', 'PAHT-CF', 'PC', 'PC-CF', 'PET-CF', 'PLA-CF', 'PETG-CF', 'PETG-GF', 'ABS-GF', 'PP-GF'], feas: ['カーボン配合', 'ガラス繊維配合', '高耐衝撃'], d: '機構部品・治具向けの高強度素材' },
    { k: 'heat', label: '熱がかかる場所', mode: 'or', mats: ['ABS', 'ASA', 'PC', 'PC-CF', 'PA', 'PA-CF', 'PA-CNF', 'PAHT-CF', 'PET-CF'], feas: [], d: '車内・機械周りなど高耐熱の素材' },
    { k: 'outdoor', label: '屋外で使う', mode: 'or', mats: ['ASA', 'ABS', 'PETG', 'ABS-GF', 'PETG-CF', 'PETG-GF'], feas: [], d: '耐候・耐水性に優れた素材' },
    { k: 'flex', label: 'やわらかいもの', mode: 'or', mats: ['TPU'], feas: [], d: 'ゴムのような弾性のTPU' },
    { k: 'light', label: '軽くしたい', mode: 'or', mats: [], feas: ['軽量発泡'], d: 'コスプレ小道具など軽さ重視の発泡系' },
    { k: 'clear', label: '透明感を出したい', mode: 'or', mats: [], feas: ['半透明・クリア'], d: '光を通す半透明・クリア系' },
    { k: 'wood', label: '木の質感', mode: 'or', mats: [], feas: ['木質調'], d: '木粉配合などウッド調の質感' },
    { k: 'unique', label: '個性派カラー', mode: 'or', mats: [], feas: ['シルク・光沢', '蓄光', 'グラデーション', 'ラメ・大理石調'], d: 'シルク・蓄光・グラデーション・ラメなど' },
    { k: 'speed', label: '高速印刷向け', mode: 'or', mats: [], feas: ['高速造形対応'], d: '高速プリント対応をうたう銘柄' },
    { k: 'support', label: '溶かせるサポート材', mode: 'or', mats: ['サポート材', 'PVA', 'HIPS'], feas: ['水溶性サポート'], d: '水溶性（PVA）やリモネン溶解（HIPS）のサポート材' }
  ];

  /* 機種プリセット: メーカー公式スペック（ノズル/ベッド上限℃・筐体・標準ノズル材質）。
     2026-08-02 bambulab.com公式スペック/PDF + wiki.bambulab.com で2ソース照合済み。
     X1Cのベッドは110℃@220V/120℃@110V＝日本(100V)は120℃を採用。
     chamber: open=開放型 / enclosed=密閉 / heated=チャンバー加熱。stock=標準搭載ノズル材質 */
  var MACHINES = [
    { id: 'a1mini', label: 'A1 mini', nozzle: 300, bed: 80, chamber: 'open', stock: 'stainless' },
    { id: 'a1', label: 'A1', nozzle: 300, bed: 100, chamber: 'open', stock: 'stainless' },
    { id: 'p1s', label: 'P1S', nozzle: 300, bed: 100, chamber: 'enclosed', stock: 'stainless' },
    { id: 'p2s', label: 'P2S', nozzle: 300, bed: 110, chamber: 'enclosed', stock: 'hardened' },
    { id: 'x1c', label: 'X1 Carbon', nozzle: 300, bed: 120, chamber: 'enclosed', stock: 'hardened' },
    { id: 'x2d', label: 'X2D', nozzle: 300, bed: 120, chamber: 'heated', stock: 'hardened' },
    { id: 'h2d', label: 'H2D', nozzle: 350, bed: 120, chamber: 'heated', stock: 'hardened' },
    { id: 'h2c', label: 'H2C', nozzle: 350, bed: 120, chamber: 'heated', stock: 'hardened' }
  ];

  /* Bambu公式フィラメントガイド（wiki.bambulab.com filament-guide-material-table）で
     enclosure=required の素材ファミリー+金属（BASF Ultrafuse 316L=密閉チャンバー要件・一次ソース2点）。
     機種選択時の注意バッジにのみ使用（除外はしない）。
     PETGは公式表では recommended だが開放機での使用が一般的なためバッジ対象外 */
  var ENCLOSURE_MATS = { 'ABS': 1, 'ABS-GF': 1, 'ASA': 1, 'PC': 1, 'PC-CF': 1,
    'PA': 1, 'PA-CF': 1, 'PA-CNF': 1, 'PAHT-CF': 1, 'PET-CF': 1, '金属': 1 };
  /* 研磨性: CF/GF強化・蓄光・ラメ/大理石調（Bambu wikiが粒子配合材としてステンレス/真鍮ノズル不可と明記）
     ・金属フィラメント（316L=ステンレス粉80%）。判定は ITEMS 構築時に i.abr へ */

  // ---- 商品データを行パースで拡張 ----
  var ITEMS = RAW.map(function (r) {
    var rowmap = {};
    (r.rows || []).forEach(function (row) {
      var i = row.indexOf('｜'); // ｜
      if (i > 0) rowmap[row.slice(0, i).trim()] = row.slice(i + 1).trim();
    });
    var nz = parseTempRow(rowmap['ノズル温度']);
    var bd = parseTempRow(rowmap['ベッド温度']);
    var w = parseWeight(rowmap['内容量']) || parseWeight(r.t);
    var dia = parseDia(rowmap['素材・径']) || parseDia(r.t);
    var hay = r.t + ' ' + (rowmap['素材・径'] || '');
    var fe = [];
    FEATURES.forEach(function (f) {
      var hit = f[1].some(function (nd) { return hay.toLowerCase().indexOf(nd.toLowerCase()) >= 0; });
      if (hit) fe.push(f[0]);
    });
    // 管理タグ由来の特徴（自由文マッチではなく運用タグの完全一致・部分一致キーで拾う）
    if (r.tags.indexOf('特性_高耐衝撃') >= 0 && fe.indexOf('高耐衝撃') < 0) fe.push('高耐衝撃');
    var fastTag = r.tags.some(function (tg) { return tg.indexOf('高速') >= 0 || tg.indexOf('PolySonic') >= 0; });
    if (fastTag && fe.indexOf('高速造形対応') < 0) fe.push('高速造形対応');
    var mval = r.m || '未分類';
    var abr = mval === '金属' ||
      fe.indexOf('カーボン配合') >= 0 || fe.indexOf('ガラス繊維配合') >= 0 ||
      fe.indexOf('蓄光') >= 0 || fe.indexOf('ラメ・大理石調') >= 0;
    var price = r.p / 100;
    return {
      t: r.t, u: r.u, v: r.v, img: r.img, m: mval,
      fe: fe, abr: abr, d: dia, w: w, p: price,
      pk: (price && w) ? Math.round(price / w * 1000) : null,
      nl: nz ? nz.lo : null, nh: nz ? nz.hi : null,
      bl: bd ? bd.lo : null, bh: bd ? bd.hi : null,
      c: r.c || null, rn: r.rn || null, ra: r.ra || null,
      inv: r.inv, av: r.av,
      pre: r.tags.indexOf('予約商品') >= 0 || r.tags.indexOf('入荷待ち') >= 0,
      ls: r.tags.indexOf('在庫限り') >= 0 || r.t.indexOf('在庫限り') >= 0,
      dry: r.tags.indexOf('要乾燥') >= 0
    };
  });

  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
  var yen = function (v) { return '¥' + Math.round(v).toLocaleString('ja-JP'); };
  // href防御: 商品URLは常にストア相対パスのはず。それ以外（スキーム付き等）は無効化
  var safeURL = function (u) { u = String(u); return u.charAt(0) === '/' ? u : '#'; };

  var MATERIALS = [], VENDORS = [], FEATS = [];
  (function () {
    var cm = {}, cv = {}, cf = {};
    ITEMS.forEach(function (i) {
      cm[i.m] = (cm[i.m] || 0) + 1; cv[i.v] = (cv[i.v] || 0) + 1;
      i.fe.forEach(function (f) { cf[f] = (cf[f] || 0) + 1; });
    });
    var sorted = function (o) {
      return Object.keys(o).sort(function (a, b) { return o[b] - o[a]; });
    };
    MATERIALS = sorted(cm); VENDORS = sorted(cv); FEATS = sorted(cf);
  })();

  var state = { q: '', mats: {}, vens: {}, feas: {}, preset: null,
    machine: null, manual: false, maxtemp: null, pkmin: null, pkmax: null,
    stock: false, nodry: false, onlyrev: false, sort: 'pk' };
  var compare = [];

  function setSize(o) { return Object.keys(o).length; }
  function setHas(o, k) { return !!o[k]; }

  function buildChips(el, values, bucket, counts) {
    el.innerHTML = '';
    values.forEach(function (v) {
      var n = ITEMS.filter(function (i) {
        if (bucket === 'feas') return i.fe.indexOf(v) >= 0;
        return (bucket === 'mats' ? i.m : i.v) === v;
      }).length;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'skff-chip';
      b.setAttribute('data-bucket', bucket); b.setAttribute('data-value', v);
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = esc(v) + '<span class="skff-cnt">' + n + '</span>';
      b.onclick = function () {
        if (state[bucket][v]) delete state[bucket][v]; else state[bucket][v] = 1;
        if (bucket === 'mats') { state.preset = null; syncPresets(); }
        syncChips(); render(); pushURL();
      };
      el.appendChild(b);
    });
  }
  function syncChips() {
    root.querySelectorAll('.skff-chip').forEach(function (c) {
      c.setAttribute('aria-pressed',
        state[c.getAttribute('data-bucket')][c.getAttribute('data-value')] ? 'true' : 'false');
    });
  }
  function presetOf() {
    for (var i = 0; i < PRESETS.length; i++) if (PRESETS[i].k === state.preset) return PRESETS[i];
    return null;
  }
  function presetPass(p, i) {
    var mOk = p.mats.indexOf(i.m) >= 0;
    var fOk = p.feas.some(function (f) { return i.fe.indexOf(f) >= 0; });
    if (p.mode === 'and') {
      if (p.mats.length && !mOk) return false;
      if (p.feas.length && !fOk) return false;
      return true;
    }
    return mOk || fOk;
  }
  function buildPresets() {
    var el = $('skff-presets'); el.innerHTML = '';
    PRESETS.forEach(function (p) {
      var n = ITEMS.filter(function (i) { return presetPass(p, i); }).length;
      if (!n) return; // 該当0件のプリセットは出さない（在庫構成の変化に自動追従）
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'skff-pbtn'; b.setAttribute('data-k', p.k);
      b.setAttribute('aria-pressed', 'false'); b.textContent = p.label;
      b.onclick = function () {
        state.preset = state.preset === p.k ? null : p.k;
        // 素材チップとの複合で0件になりやすいため、プリセット適用時はチップ選択を解除（チップ側の逆も同様）
        if (state.preset && setSize(state.mats)) { state.mats = {}; syncChips(); }
        syncPresets(); render(); pushURL();
      };
      el.appendChild(b);
    });
  }
  function syncPresets() {
    root.querySelectorAll('.skff-pbtn').forEach(function (b) {
      b.setAttribute('aria-pressed', state.preset === b.getAttribute('data-k') ? 'true' : 'false');
    });
    var p = presetOf();
    $('skff-pdesc').textContent = p ? '適用中: ' + p.d : '';
  }

  function basePass(i, skipPk) {
    var pr = presetOf();
    if (pr && !presetPass(pr, i)) return false;
    if (setSize(state.mats) && !setHas(state.mats, i.m)) return false;
    if (setSize(state.vens) && !setHas(state.vens, i.v)) return false;
    if (setSize(state.feas)) {
      var all = Object.keys(state.feas).every(function (f) { return i.fe.indexOf(f) >= 0; });
      if (!all) return false;
    }
    if (state.stock && !i.inv) return false;
    if (state.nodry && i.dry) return false;
    if (state.onlyrev && !i.rn) return false;
    if (!skipPk) {
      if (state.pkmin !== null && (i.pk === null || i.pk < state.pkmin)) return false;
      if (state.pkmax !== null && (i.pk === null || i.pk > state.pkmax)) return false;
    }
    if (state.q) {
      var hay = (i.t + ' ' + i.v + ' ' + i.m + ' ' + i.fe.join(' ')).toLowerCase();
      if (hay.indexOf(state.q) < 0) return false;
    }
    return true;
  }
  function machineOf() {
    for (var i = 0; i < MACHINES.length; i++) if (MACHINES[i].id === state.machine) return MACHINES[i];
    return null;
  }
  // 適合判定は「推奨レンジ下限 ≤ プリンタ上限」（上限基準は印刷可能な商品まで落とすため不可）
  // 機種選択時はノズルに加えベッド上限でも判定する
  function filtered() {
    var mc = machineOf();
    var cap = mc ? mc.nozzle : state.maxtemp;
    return ITEMS.filter(function (i) {
      if (!basePass(i)) return false;
      if (cap !== null && (i.nl === null || i.nl > cap)) return false;
      if (mc && (i.bl === null || i.bl > mc.bed)) return false;
      return true;
    });
  }
  // 「未整備のため絞り込み対象外＝非表示」になった件数を種類別に案内（黙って消さない）
  function unknownNote() {
    var mc = machineOf();
    var parts = [];
    if (mc !== null || state.maxtemp !== null) {
      var t = ITEMS.filter(function (i) {
        return basePass(i) && (i.nl === null || (mc && i.bl === null));
      }).length;
      if (t) parts.push('温度データ未整備の ' + t + ' 件');
    }
    if (state.pkmin !== null || state.pkmax !== null) {
      var w = ITEMS.filter(function (i) { return basePass(i, true) && i.pk === null; }).length;
      if (w) parts.push('内容量未整備の ' + w + ' 件');
    }
    var note = parts.length ? '（' + parts.join('・') + 'は判定できないため表示していません）' : '';
    // Liquid の paginate 上限250を超えた分。条件に関係なく常に出す（黙って切り詰めない）
    if (OMITTED > 0) {
      note += '（取扱数が検索の上限250件を超えたため ' + OMITTED + ' 件を読み込めていません）';
    }
    return note;
  }

  var SORT_KEYS = ['pk', 'price', 'temp', 'colors', 'rev', 'name'];
  function sortItems(list) {
    var lo = function (v) { return (v === null || v === undefined) ? Infinity : v; };
    var hi = function (v) { return (v === null || v === undefined) ? -Infinity : v; };
    var num = function (a, b) { return a === b ? 0 : a - b; }; // 両者同値（±Infinity含む）で0＝NaN回避
    var SORTS = {
      pk: function (a, b) { return num(lo(a.pk), lo(b.pk)); },
      price: function (a, b) { return num(lo(a.p), lo(b.p)); },
      temp: function (a, b) { return num(lo(a.nl), lo(b.nl)); },
      colors: function (a, b) { return num(hi(b.c), hi(a.c)); },
      rev: function (a, b) { return num(hi(b.ra), hi(a.ra)) || num(hi(b.rn), hi(a.rn)); },
      name: function (a, b) { return a.t.localeCompare(b.t, 'ja'); }
    };
    var by = SORT_KEYS.indexOf(state.sort) >= 0 ? SORTS[state.sort] : SORTS.pk;
    return list.slice().sort(by);
  }

  function thermal(i) {
    if (i.nl === null) return '<div class="skff-therm"><span class="skff-nodata">温度データ未整備</span></div>';
    var lo = Math.max(0, (i.nl - T_LO) / (T_HI - T_LO) * 100);
    var hi = Math.min(100, (i.nh - T_LO) / (T_HI - T_LO) * 100);
    var bed = i.bl !== null
      ? '<span class="skff-bed">ベッド ' + (i.bl === i.bh ? i.bl : i.bl + '–' + i.bh) + '℃</span>' : '';
    return '<div class="skff-therm">' +
      '<div class="skff-tlabel"><span class="skff-mono">ノズル ' +
      (i.nl === i.nh ? i.nl : i.nl + '–' + i.nh) + '℃</span>' + bed + '</div>' +
      '<div class="skff-tscale"><span class="skff-tband" style="left:' + lo.toFixed(1) +
      '%;width:' + Math.max(1.5, hi - lo).toFixed(1) + '%"></span></div>' +
      '<div class="skff-taxis"><span>' + T_LO + '</span><span>' + T_HI + '℃</span></div></div>';
  }
  function stockLabel(i) {
    if (i.inv) return '即納';
    // 予約タグは購入可能なときだけ信じる。売り切れて購入できない商品に「予約・入荷待ち」を出すと
    // 「今注文すれば入荷後に届く」と読めてしまうため（2026-08-03: 実データ86件中1件が該当）。
    if (i.pre && !i.ls && i.av) return '予約・入荷待ち'; // 在庫限り品の残存予約タグは再入荷示唆になるため出さない
    if (i.av) return '受注・取り寄せ';           // 在庫追跡なし・受注生産でも購入可能な商品
    return '在庫なし';
  }
  function flags(i, mc) {
    var out = [];
    var st = stockLabel(i);
    if (st === '即納') out.push('<span class="skff-flag skff-f-ok">即納</span>');
    else if (st !== '在庫なし') out.push('<span class="skff-flag skff-f-pre">' + st + '</span>');
    if (i.ls) out.push('<span class="skff-flag skff-f-pre">在庫限り</span>');
    if (i.dry) out.push('<span class="skff-flag skff-f-dry">要乾燥</span>');
    if (mc && mc.chamber === 'open' && ENCLOSURE_MATS[i.m]) {
      out.push('<span class="skff-flag skff-f-warn">エンクロージャ推奨</span>');
    }
    if (mc && mc.stock !== 'hardened' && i.abr) {
      out.push('<span class="skff-flag skff-f-warn">硬化ノズル推奨</span>');
    }
    return out.join('');
  }

  function render() {
    var mc = machineOf();
    var list = sortItems(filtered());
    $('skff-rnum').textContent = list.length;
    $('skff-rnote').textContent = unknownNote();
    $('skff-scount').textContent = list.length;
    var pks = list.map(function (i) { return i.pk; }).filter(function (v) { return v !== null; })
      .sort(function (a, b) { return a - b; });
    $('skff-smedian').textContent = pks.length ? yen(pks[Math.floor(pks.length / 2)]) : '—';
    $('skff-smin').textContent = pks.length ? yen(pks[0]) : '—';
    $('skff-sstock').textContent = list.filter(function (i) { return i.inv; }).length;

    var el = $('skff-list');
    if (!list.length) {
      el.className = '';
      el.innerHTML = '<div class="skff-empty">条件に合うフィラメントがありません。<br>条件を減らすか「条件を解除」をお試しください。</div>';
      return;
    }
    el.className = 'skff-list';
    el.innerHTML = list.map(function (i) {
      var idx = ITEMS.indexOf(i);
      return '<article class="skff-item">' +
        (i.img ? '<img class="skff-thumb" src="' + esc(i.img) + '" alt="" loading="lazy" width="60" height="60">'
          : '<span class="skff-thumb"></span>') +
        '<div class="skff-iname">' +
        '<a href="' + esc(safeURL(i.u)) + '">' + esc(i.t) + '</a>' +
        '<div class="skff-meta"><span class="skff-mat">' + esc(i.m) + '</span>' +
        '<span>' + esc(i.v) + '</span>' +
        (i.d ? '<span>φ' + i.d + 'mm</span>' : '') +
        (i.w ? '<span>' + (i.w >= 1000 ? (i.w / 1000) + 'kg' : i.w + 'g') + '</span>' : '') +
        (i.c >= 2 ? '<span>' + i.c + '色</span>' : '') +
        (i.rn ? '<span class="skff-rev">★' + (+i.ra).toFixed(1) + ' (' + i.rn + ')</span>' : '') +
        i.fe.map(function (f) { return '<span class="skff-feat">' + esc(f) + '</span>'; }).join('') +
        flags(i, mc) +
        '</div></div>' +
        '<div class="skff-price">' +
        (i.pk !== null ? '<div class="skff-pk skff-mono">' + yen(i.pk) + '<small>/kg</small></div>'
          : '<div class="skff-nodata">内容量未整備</div>') +
        '<div class="skff-praw skff-mono">本体 ' + yen(i.p) + '</div>' +
        '</div>' +
        thermal(i) +
        '<label class="skff-cmpbox"><input type="checkbox" data-idx="' + idx + '"' +
        (compare.indexOf(idx) >= 0 ? ' checked' : '') + ' aria-label="比較に追加: ' + esc(i.t) + '"></label>' +
        '</article>';
    }).join('');

    el.querySelectorAll('.skff-cmpbox input').forEach(function (cb) {
      cb.onchange = function () {
        var k = +cb.getAttribute('data-idx');
        if (cb.checked) {
          if (compare.length >= 4) { cb.checked = false; return; }
          compare.push(k);
        } else compare = compare.filter(function (x) { return x !== k; });
        syncCompare();
      };
    });
  }

  function syncCompare() {
    $('skff-cmpn').textContent = compare.length;
    $('skff-cmpbar').classList.toggle('skff-on', compare.length > 0);
  }

  var CMP_ROWS = [
    ['ブランド', function (i) { return i.v; }, null, null],
    ['素材', function (i) { return i.m; }, null, null],
    ['特徴', function (i) { return i.fe.join(' / ') || '—'; }, null, null],
    ['価格 / kg', function (i) { return i.pk !== null ? yen(i.pk) : '—'; }, function (i) { return i.pk; }, 'min'],
    ['本体価格', function (i) { return yen(i.p); }, function (i) { return i.p; }, 'min'],
    ['内容量', function (i) { return i.w ? (i.w >= 1000 ? i.w / 1000 + 'kg' : i.w + 'g') : '—'; }, null, null],
    ['径', function (i) { return i.d ? 'φ' + i.d + 'mm' : '—'; }, null, null],
    ['ノズル温度', function (i) { return i.nl !== null ? i.nl + '–' + i.nh + '℃' : '未整備'; }, null, null],
    ['ベッド温度', function (i) { return i.bl !== null ? i.bl + '–' + i.bh + '℃' : '未整備'; }, null, null],
    ['選べる色数', function (i) { return i.c >= 2 ? i.c + '色' : '—'; }, function (i) { return i.c >= 2 ? i.c : null; }, 'max'],
    ['レビュー', function (i) { return i.rn ? '★' + (+i.ra).toFixed(1) + '（' + i.rn + '件）' : '—'; }, function (i) { return i.ra; }, 'max'],
    ['注意', function (i) {
      var mc = machineOf(); var out = [];
      if (mc && mc.chamber === 'open' && ENCLOSURE_MATS[i.m]) out.push('エンクロージャ推奨');
      if (mc && mc.stock !== 'hardened' && i.abr) out.push('硬化ノズル推奨');
      if (i.dry) out.push('要乾燥');
      return out.join(' / ') || '—';
    }, null, null],
    ['在庫', function (i) { return stockLabel(i) + (i.ls ? '（在庫限り）' : ''); }, null, null]
  ];
  function openCompare() {
    var list = compare.map(function (k) { return ITEMS[k]; });
    if (!list.length) return;
    var html = '<table class="skff-ctable"><thead><tr><th></th>' +
      list.map(function (i) { return '<th><a href="' + esc(safeURL(i.u)) + '">' + esc(i.t) + '</a></th>'; }).join('') +
      '</tr></thead><tbody>';
    CMP_ROWS.forEach(function (row) {
      var nums = null, bestVal = null;
      if (row[2] && row[3]) {
        nums = list.map(row[2]).map(function (v) { return (v === null || v === undefined) ? null : +v; });
        var valid = nums.filter(function (v) { return v !== null; });
        if (valid.length > 1) {
          bestVal = row[3] === 'min' ? Math.min.apply(null, valid) : Math.max.apply(null, valid);
        }
      }
      html += '<tr><th>' + row[0] + '</th>' +
        list.map(function (i, k) {
          var best = bestVal !== null && nums[k] !== null && nums[k] === bestVal; // 同値タイは全列ハイライト
          return '<td class="' + (best ? 'skff-best' : '') + '">' + esc(row[1](i)) + '</td>';
        }).join('') + '</tr>';
    });
    html += '</tbody></table>';
    $('skff-mbody').innerHTML = html;
    $('skff-overlay').classList.add('skff-on');
  }

  function pushURL() {
    var p = new URLSearchParams();
    if (state.q) p.set('q', state.q);
    if (setSize(state.mats)) p.set('m', Object.keys(state.mats).join(','));
    if (setSize(state.vens)) p.set('v', Object.keys(state.vens).join(','));
    if (setSize(state.feas)) p.set('f', Object.keys(state.feas).join(','));
    if (state.preset) p.set('pr', state.preset);
    if (state.machine) p.set('mc', state.machine);
    if (state.manual && state.maxtemp !== null) p.set('t', state.maxtemp);
    if (state.pkmin !== null) p.set('pmin', state.pkmin);
    if (state.pkmax !== null) p.set('pmax', state.pkmax);
    if (state.stock) p.set('stock', '1');
    if (state.nodry) p.set('dry', '1');
    if (state.onlyrev) p.set('rev', '1');
    if (state.sort !== 'pk') p.set('s', state.sort);
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }
  function readURL() {
    var p = new URLSearchParams(location.search);
    var setOf = function (s) { var o = {}; s.split(',').forEach(function (x) { if (x) o[x] = 1; }); return o; };
    if (p.get('q')) { state.q = p.get('q').toLowerCase(); $('skff-q').value = p.get('q'); }
    if (p.get('m')) state.mats = setOf(p.get('m'));
    if (p.get('v')) state.vens = setOf(p.get('v'));
    if (p.get('f')) state.feas = setOf(p.get('f'));
    if (p.get('pr')) { state.preset = p.get('pr'); if (!presetOf()) state.preset = null; }
    if (p.get('mc')) { state.machine = p.get('mc'); if (!machineOf()) state.machine = null; }
    var tn = parseFloat(p.get('t'));
    if (!state.machine && isFinite(tn) && tn > 0) { state.manual = true; state.maxtemp = tn; $('skff-maxtemp').value = tn; }
    var pn = parseFloat(p.get('pmin'));
    if (isFinite(pn) && pn >= 0) { state.pkmin = pn; $('skff-pkmin').value = pn; }
    var px = parseFloat(p.get('pmax'));
    if (isFinite(px) && px >= 0) { state.pkmax = px; $('skff-pkmax').value = px; }
    if (p.get('stock') === '1') { state.stock = true; $('skff-fstock').checked = true; }
    if (p.get('dry') === '1') { state.nodry = true; $('skff-fdry').checked = true; }
    if (p.get('rev') === '1') { state.onlyrev = true; $('skff-frev').checked = true; }
    var s = p.get('s');
    if (s && SORT_KEYS.indexOf(s) >= 0) { state.sort = s; $('skff-sort').value = s; }
  }

  function buildMachines() {
    var og = $('skff-mgroup');
    MACHINES.forEach(function (m) {
      var o = document.createElement('option');
      o.value = m.id; o.textContent = m.label;
      og.appendChild(o);
    });
  }
  var CHAMBER_LABEL = { open: '開放型', enclosed: '密閉型', heated: '密閉型・チャンバー加熱' };
  function syncMachine() {
    var mc = machineOf();
    var sel = $('skff-machine');
    $('skff-manualtemp').hidden = !state.manual;
    if (mc) {
      sel.value = mc.id;
      $('skff-mspec').textContent = 'ノズル上限 ' + mc.nozzle + '℃・ベッド上限 ' + mc.bed + '℃・' +
        (CHAMBER_LABEL[mc.chamber] || '') + ' として判定します。';
    } else {
      sel.value = state.manual ? 'other' : '';
      $('skff-mspec').textContent = '';
    }
  }

  // ---- 起動 ----
  buildPresets();
  buildMachines();
  buildChips($('skff-cmat'), MATERIALS, 'mats');
  buildChips($('skff-cfea'), FEATS, 'feas');
  buildChips($('skff-cven'), VENDORS, 'vens');
  readURL(); syncChips(); syncPresets(); syncMachine();

  $('skff-q').oninput = function (e) { state.q = e.target.value.trim().toLowerCase(); render(); pushURL(); };
  $('skff-machine').onchange = function (e) {
    var v = e.target.value;
    state.machine = null; state.manual = v === 'other';
    if (v && v !== 'other') state.machine = v;
    if (!state.manual) { state.maxtemp = null; $('skff-maxtemp').value = ''; }
    syncMachine(); render(); pushURL();
  };
  $('skff-maxtemp').oninput = function (e) { state.maxtemp = e.target.value === '' ? null : +e.target.value; render(); pushURL(); };
  $('skff-pkmin').oninput = function (e) { state.pkmin = e.target.value === '' ? null : +e.target.value; render(); pushURL(); };
  $('skff-pkmax').oninput = function (e) { state.pkmax = e.target.value === '' ? null : +e.target.value; render(); pushURL(); };
  $('skff-fstock').onchange = function (e) { state.stock = e.target.checked; render(); pushURL(); };
  $('skff-fdry').onchange = function (e) { state.nodry = e.target.checked; render(); pushURL(); };
  $('skff-frev').onchange = function (e) { state.onlyrev = e.target.checked; render(); pushURL(); };
  $('skff-sort').onchange = function (e) { state.sort = e.target.value; render(); pushURL(); };
  $('skff-reset').onclick = function () {
    state = { q: '', mats: {}, vens: {}, feas: {}, preset: null,
      machine: null, manual: false, maxtemp: null,
      pkmin: null, pkmax: null, stock: false, nodry: false, onlyrev: false, sort: 'pk' };
    $('skff-q').value = ''; $('skff-maxtemp').value = ''; $('skff-pkmin').value = ''; $('skff-pkmax').value = '';
    $('skff-fstock').checked = false; $('skff-fdry').checked = false; $('skff-frev').checked = false;
    $('skff-sort').value = 'pk';
    syncChips(); syncPresets(); syncMachine(); render(); pushURL();
  };
  $('skff-share').onclick = function () {
    var btn = $('skff-share');
    var done = function (ok) {
      btn.textContent = ok ? 'コピーしました' : 'コピーできません';
      setTimeout(function () { btn.textContent = '条件をコピー'; }, 1600);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(function () { done(true); }, function () { done(false); });
    else done(false);
  };
  $('skff-cmpclear').onclick = function () { compare = []; syncCompare(); render(); };
  $('skff-cmpopen').onclick = openCompare;
  $('skff-mclose').onclick = function () { $('skff-overlay').classList.remove('skff-on'); };
  $('skff-overlay').onclick = function (e) { if (e.target.id === 'skff-overlay') e.currentTarget.classList.remove('skff-on'); };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $('skff-overlay').classList.remove('skff-on');
  });

  render();
})();
